import React from "react";
import {connect} from "react-redux";
import {Platform, StyleSheet, Text, View} from "react-native";
import {compose} from "redux";
import {withTranslation} from "react-i18next";


class PostCategorie extends React.Component{
    constructor(props) {
        super();
    }

    _getStyle(type, prefix) {
        const defaultLabels = {
          news: this.props.t("News"), synthesis: this.props.t("Synthese"), memo: this.props.t("Memo")
        }

        let label = defaultLabels[type];

        if (prefix !== undefined) {
          label = prefix + " " + label ;
        }

        switch (type) {
            case 'news' :
                return {label, color : this.props.theme.colors.secondary.green1.value, backgroundColor : this.props.theme.colors.secondary.green3.value};
            case 'synthesis':
                label  = (this.props.i18n.language=='fr' && prefix>1)? label+'s': label;
                return {label, color : this.props.theme.colors.secondary.pink1.value, backgroundColor : this.props.theme.colors.secondary.pink3.value};
            case 'memo':
                label  = (this.props.i18n.language=='fr' && prefix>1)? label+'s': label;
                return {label, color : this.props.theme.colors.secondary.orange1.value, backgroundColor : this.props.theme.colors.secondary.yellow2.value};
        }
    }
    render() {
        let s = this._getStyle(this.props.type, this.props.prefix);

        const styles = StyleSheet.create({
            typePost:{
                color : s.color,
                backgroundColor : s.backgroundColor,
                borderRadius: Platform.select({ios:13 ,android:40,web:40}) ,
                paddingTop:3,
                paddingHorizontal: Platform.select({ios:10 ,android:15,web:15}) ,
                paddingVertical:3,
                fontFamily:this.props.theme.fonts.text,
                fontWeight:"700",
                fontSize:14,
                overflow:"hidden"
            }
        });

        return <Text style={styles.typePost}>{s.label}</Text>;
    }

}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default compose(withTranslation(),connect(mapStateToProps))(PostCategorie);
